import { render, staticRenderFns } from "./OutDrugBatch.vue?vue&type=template&id=2c44dce4&scoped=true&lang=pug&"
import script from "./OutDrugBatch.vue?vue&type=script&lang=ts&"
export * from "./OutDrugBatch.vue?vue&type=script&lang=ts&"
import style0 from "./OutDrugBatch.vue?vue&type=style&index=0&id=2c44dce4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c44dce4",
  null
  
)

export default component.exports